import { render, staticRenderFns } from "./RoleTray.vue?vue&type=template&id=1bcf50c4&scoped=true"
import script from "./RoleTray.vue?vue&type=script&lang=js"
export * from "./RoleTray.vue?vue&type=script&lang=js"
import style0 from "./RoleTray.vue?vue&type=style&index=0&id=1bcf50c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf50c4",
  null
  
)

export default component.exports